import PropTypes from 'prop-types'
import React from 'react'
import Link from 'gatsby-link'

import { rhythm, scale } from '../utils/typography'
import Bio from '../components/Bio'
import ReadingTime from '../components/ReadingTime'

const Home = ({ data }) => (
  <div>
    <Bio />
    <h1>Writings</h1>
    {data.allMarkdownRemark.edges.map(({ node }) => {
      return (
        <div key={node.frontmatter.path}>
          <h2 css={{ marginTop: rhythm(1) }}>
            <Link to={node.frontmatter.path}>{node.frontmatter.title}</Link>
          </h2>
          <p
            css={{
              ...scale(-1 / 5),
              display: 'block',
              marginBottom: rhythm(1 / 2),
              marginTop: rhythm(-0.8),
              color: 'hsla(0,0%,0%,0.34)'
            }}>
            {node.frontmatter.date}
            <ReadingTime words={node.frontmatter.words} />
          </p>
          <p dangerouslySetInnerHTML={{ __html: node.frontmatter.excerpt }} />
        </div>
      )
    })}
  </div>
)

Home.propTypes = {
  data: PropTypes.object.isRequired
}

export const query = graphql`
  query Home {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            words
            excerpt
          }
        }
      }
    }
  }
`

export default Home



// WEBPACK FOOTER //
// ./src/pages/index.js